import { FaqCategoryDialogComponent } from './faq-category-dialog/faq-category-dialog.component';
import { Component, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { ConfigSection } from '../config-section';
import { FaqCategoryHttpService } from './services/faq-category-http.service';
import { FaqCategoryDto } from '@feature/_app_modules/responsive-faq/faq.types';

@Component({
  selector: 'faq-category',
  templateUrl: './faq-category.component.html'
})
export class FaqCategoriesComponent extends ConfigSection<FaqCategoryDto[]> {

    /**
     * An array of forms maintained with the edited items
     */
    forms: FormGroup[] = [];

    /**
     * The array of faq categories, retrieved from the server and then edited in memory.
     * All written at once during save
     */
    faqCategories: FaqCategoryDto[];

    selectedFaqCategories: FaqCategoryDto[] = [];

    /**
     * A reference for the faq category dialog which can be used for adding new categories
     * and edited existing categories
     */
    @ViewChild(FaqCategoryDialogComponent) faqCategoryDialog;

    private isModified: boolean = false;

    constructor(
        private readonly httpService: FaqCategoryHttpService
    ) {
        super();
    }

    get modified(): boolean {
        return this.isModified;
    }

    get valid(): boolean {
        return (this.forms.length === 0  || this.forms.every( f=> f.valid ));
    }

    protected initialiseConfig(): Observable<FaqCategoryDto[]> {
        this.httpService.loadCategories().subscribe(categories => {
            this.faqCategories = categories.sort((a, b) => (a.Order - b.Order));
        });
        return of(this.faqCategories);
    }

    protected createForm(config: FaqCategoryDto[]): void {
    }

    submit(): Observable<boolean> {
        this.faqCategories.forEach((category, index) => (category.Order = index + 1))

        return this.httpService.saveCategories(this.faqCategories);
    }

    onReorder(){
        this.isModified = true;
    }

    /**
     * Handles the save event raised from the new item dialog
     * @param faqCategory
     */
    handleFaqCategorySave(faqCategory: FaqCategoryDto){
        this.isModified = true;
        const categories = [...this.faqCategories];

        if(this.selectedFaqCategories && this.selectedFaqCategories?.length > 0){
            const index = this.faqCategories.indexOf(this.selectedFaqCategories[0], 0);
            categories[index] = faqCategory;
        }else{
            categories.push(faqCategory);
        }

        this.faqCategories = categories;
        this.resetSelectedCategories();
    }

    /** Show the add new faq category dialog */
    showAddDialog() {
        this.resetSelectedCategories();
        this.faqCategoryDialog.showAddNewFaqCategoryDialog();
    }

    /** Show the edit faq category dialog */
    showEditDialog(){
        this.faqCategoryDialog.showEditFaqCategoryDialog(this.selectedFaqCategories[0]);
    }

    /** Handles the delete faq category event */
    onCategoryDelete(){
        this.isModified = true;
        const index = this.faqCategories.indexOf(this.selectedFaqCategories[0], 0);
        const categories = [...this.faqCategories];
        categories.splice(index, 1);
        this.faqCategories = categories;
        this.resetSelectedCategories();
    }

    /** Determines whether a category is selected to be edited */
    showEditButton(): boolean{
        return (this.selectedFaqCategories && this.selectedFaqCategories.length > 0);
    }

    /** Determines whether a category is selected and can be deleted */
    showDeleteButton(): boolean{
        return (this.selectedFaqCategories && this.selectedFaqCategories.length > 0 && !this.selectedFaqCategories[0].IsGeneralEnquiry);
    }

    resetSelectedCategories(){
        this.selectedFaqCategories = [];
    }
}
